import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { IExpensesSearch } from "../../screens/expenses/ExpensesViewController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export interface IExpensesPayload {
  title: string;
  expense_head: string;
  expense_date?: string;
  amount?: number;
  payment_method: string;
  transaction_reference?: string;
  receipt_media_url?: string;
  description?: string;
}

export const GET_ALL_EXPENSES = (
  pagination: IPagination,
  search: string,
  advanceSearch: IExpensesSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_expenses.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${
        advanceSearch.expenseFromDate
          ? `&expense_from_date=${advanceSearch.expenseFromDate}`
          : ""
      }${
        advanceSearch.expenseToDate
          ? `&expense_to_date=${advanceSearch.expenseToDate}`
          : ""
      }${
        advanceSearch.transactionReference.length > 0
          ? `&transaction_reference=${advanceSearch.transactionReference}`
          : ""
      }${
        advanceSearch.expenseHead
          ? `&expense_head=${advanceSearch.expenseHead}`
          : ""
      }${
        advanceSearch.paymentMethod
          ? `&payment_method=${advanceSearch.paymentMethod}`
          : ""
      }`,

    API_ENDPOINTS.get_all_expenses.method
  );

export const GET_EXPENSES_BY_ID = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_expenses.url + `/${id}`,

    API_ENDPOINTS.get_all_expenses.method
  );

export const DELETE_EXPENSE = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_expenses.url + `/${id}`,
    API_ENDPOINTS.delete_expenses.method
  );
};

export const UPDATE_EXPENSE = (payload: IExpensesPayload, id: string) => {
  return serviceMaker(
    API_ENDPOINTS.update_expenses.url + `/${id}`,
    API_ENDPOINTS.update_expenses.method,
    payload
  );
};

export const CREATE_EXPENSE = (payload: IExpensesPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_expenses.url,
    API_ENDPOINTS.create_expenses.method,
    payload
  );
};
